import { Outlet } from "react-router-dom";

import { navigationV2 } from "@src/shared/navigation/v2";
import { ActorProvider } from "@src/shared/providers/actorProvider";

export function AuthenticatedV2Route() {
  return (
    <ActorProvider loginUrl={navigationV2.login}>
      <Outlet />
    </ActorProvider>
  );
}
